import { render, staticRenderFns } from "./AddExpertDialog.vue?vue&type=template&id=7a0c512c&scoped=true"
import script from "./AddExpertDialog.vue?vue&type=script&lang=js"
export * from "./AddExpertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c512c",
  null
  
)

export default component.exports